import { Action, createReducer, on } from '@ngrx/store';

import { ModalDeliveryShareModel, SharedReason } from '../../../../../core/models';
import * as fromActions from './modal-delivery-share.actions';

export interface DeliveryShareState {
  share: ModalDeliveryShareModel;
  reasons: SharedReason[];
  loading: boolean;
  loaded: boolean;
}

export const initialState: DeliveryShareState = <DeliveryShareState>{
  share: {
    distributionKeyCode: '',
    emailAddress: '',
    firstName: '',
    lastName: '',
    reasonForSharing: '',
    userEvent: 'PORTAL_DELIVERY_SHARE',
  },
  reasons: [],
  loading: false,
  loaded: false,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
// eslint-disable-next-line no-underscore-dangle
const _deliveryShareReducer = createReducer(
  initialState,
  on(fromActions.sendDelivery, (state: DeliveryShareState, { deliveryShare }) => ({
    ...state,
    share: deliveryShare,
  })),
  on(fromActions.sendDeliverySuccess, (state: DeliveryShareState) => (
    { ...state, loading: false, loaded: true }
  )),
  on(
    fromActions.sendDeliveryError,
    fromActions.loadSharedReasonError,
    (state: DeliveryShareState) => ({ ...state, loading: false, loaded: false }),
  ),
  on(fromActions.loadSharedReasonSuccess, (state: DeliveryShareState, action) => {
    const { reasons } = action;
    return { ...state, reasons, loading: false, loaded: true };
  }),
);

export function modalDeliveryShareReducer(state: DeliveryShareState, action: Action) {
  return _deliveryShareReducer(state, action);
}

export const mainDeliveryShareKey = 'mainDeliveryShare';
